export const NETWORK_LABELS = 'A&E,ABC,Adult Swim,AMC,Animal Planet,BBCA,BET,BRAVO,Cartoon Network,CBS,Comedy Central,Discovery,Disney Channel,E!,ESPN,Food Network,FOX,Freeform,FX,HBO,HGTV,History,Lifetime,MTV,National Geographic Channel,NBC,Nickelodeon,OWN,Oxygen,PBS,Showtime,Starz,SyFy,TBS,Telemundo,The CW,TLC,TNT,truTV,Univision,USA,VH1,We TV'

export const STREAMING_LABELS = 'Hulu,Amazon,Netflix,Disney+,Apple TV+,HBO Max,Paramount+,Discovery+'

export const ADMIN_ONLY_TLM_LABELS = 'Disney+,Apple TV+'

export const BRAND_DERIVED_LABELS = 'Baby & Kids,CPG - Alcohol,CPG - Beauty,CPG - Beverage,CPG - Candy & Gum,CPG - Food,CPG - Home & Laundry,CPG - Personal Care,CPG - Pet Care,Media & News,Airline,Appliances,Automotive,CPG,Entertainment,Finance,Fitness,Gaming,Hotel,Insurance,Pharmaceuticals,Podcasts,QSR,Restaurant,Retail,Services,Technology,Telecommunication,Travel,Real Estate,Industrial'

export const FILTER_OUT_GENRES = 'Talk,Special,News,Procedural'

export const GENRE_MAPPINGS = 'Action,Comedy,Drama,Documentary,Game Show / Competition,Sci-Fi,Spanish,Sports,Reality,Sitcom,Action and Adventure,Kids and Family,Lifestyle,Science Fiction,Docuseries'

export const SPECIAL_LABEL = 'Special'

export const NBC_SHOWS_TO_REMOVE = 'Today,Meet the Press,Days Of Our Lives,Brooklyn Nine-Nine,Dateline NBC'

export const NBC_NETWORK = '3bea59b5-90d8-4c3e-96c1-53b5d634147f'

export const DISTRIBUTION_LABELS = 'Linear,Streaming,Theatrical Release,Others'

export const ATTENTION_INDEX_STREAMING_LABELS = 'Amazon,Hulu,Netflix,Disney+,Apple TV+,Roku Originals,HBO Max,Peacock,BET+,AMC+,Shudder,IGTV,Spectrum,Acorn TV,Sony Crackle,Pluto TV,Tubi,Discovery+,Curiosity Stream,Paramount+,ALLBLK,Sundance TV'